// extracted by mini-css-extract-plugin
export default {"main_sec":"styles_main_sec__ekJ9q","tabContent":"styles_tabContent__crD2L","button":"styles_button__CgSWZ"};